<app-detail-main-template>
  <div container-header>
    <div class="statistics"></div>
    <div class="filters">
      <app-landing-filter (addFilter)="applyFilter($event)"></app-landing-filter>
    </div>
  </div>
  <div container-body>
    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-12 p-lg-12"
           *ngIf="chaseStatusLabelModel !== undefined">
        <app-kpi [cModel]="chaseStatusChartModel"
                 [cDataLabels]="chaseStatusLabelModel"
                 [cDataModel]="chaseStatusArray"
                 [cOptions]="chaseStatusDataOptions"></app-kpi>
      </div>
    </div>
    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-12 p-lg-12"
           *ngIf="numeratorHitsLabelModel !== undefined">
        <app-kpi [cModel]="numeratorHitsChartModel"
                 [cDataLabels]="numeratorHitsLabelModel"
                 [cDataModel]="numeratorHitsArray"
                 [cOptions]="numeratorHitsDataOptions"></app-kpi>
      </div>
    </div>
    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-12 p-lg-12"
           *ngIf="retrievalProjectionsLabelModel !== undefined">
        <app-kpi [cModel]="retrievalProjectionsChartModel"
                 [cDataLabels]="retrievalProjectionsLabelModel"
                 [cDataModel]="retrievalProjectionsArray"
                 [cOptions]="retrievalProjectionsDataOptions"></app-kpi>
      </div>
    </div>
  </div>
</app-detail-main-template>